import React from 'react';

import { HelpLandingPage } from '@ergeon/help-components';

import { defaultCategories } from 'data/help-categories';

const LandingPage = (props) => {
  return (
    <HelpLandingPage
      categories={defaultCategories}
      isLargeIcons
      subtitle={`Here you can access the complete
        documentation and playbooks for the
        company and each business function`}
      title="Ergeon Wiki"
      {...props} />
  );
};

export default LandingPage;
